import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { LinkasRouterLink, useNavigate } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import copyOutline from '@iconify/icons-eva/copy-outline';
import { toast } from 'react-hot-toast';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import isEligible from '../../../utils/roleEligibleGetter';

// ----------------------------------------------------------------------

SettingMoreMenu.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  rowData: PropTypes.object.isRequired
};
export default function SettingMoreMenu({ onUpdate, rowData }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const theme = useTheme();

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          sx={{
            color: rowData?.status?.toLowerCase() === 'active' ? 'orange' : 'green'
          }}
          onClick={() => onUpdate(rowData)}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          {rowData?.status?.toLowerCase() === 'active' ? (
            <ListItemText primary="Inactive" primaryTypographyProps={{ variant: 'body2' }} />
          ) : (
            <ListItemText primary="Active" primaryTypographyProps={{ variant: 'body2' }} />
          )}
        </MenuItem>
      </Menu>
    </>
  );
}
